import { combineRules } from 'fela';

import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = () => ({
    paddingBlock: '1.5rem',
});

export const billingTitle: TRuleWithTheme = ({ theme }) => ({
    marginBottom: '0.5rem',
});

export const billingRow: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',

    justifyContent: 'space-between',
    flexDirection: 'column',
    paddingBlock: '0.5rem',

    '& > p': {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.31rem',
    },

    min480: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: '1rem',

        paddingBlock: 0,
        minHeight: '2.5rem',
    },
});

export const billingValueContainer: TRuleWithTheme = ({ theme }) => ({
    minWidth: '7.5rem',
    color: theme.colors.foregroundsTertiary,
});

export const interval: TRuleWithTheme = ({ theme }) => ({
    color: theme.colors.foregroundsTertiary,
});

export const billingValue: TRuleWithTheme = ({ theme }) => ({
    color: theme.colors.foregroundsPrimary,
    fontSize: '1.25rem',
    fontWeight: 600,
    lineHeight: '1.125rem',
});

export const totalPrice: TRuleWithTheme = combineRules(billingValue, ({ theme }) => ({
    color: theme.colors.accentPrimary,
}));

export const divider: TRuleWithTheme = ({ theme }) => ({
    borderColor: theme.colors.foregroundsSeparator,
    margin: 0,
});

export const tooltipButton: TRuleWithTheme = () => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'help',
});
